import { FC } from 'react';
import { useCountdown } from 'src/hooks/useCountdown';

interface CountdownProps {
    timer: {
        seconds: number;
        minutes?: number;
    };
    onStop?: (time?: { seconds: string; minutes?: string }) => boolean;
}

export const Countdown: FC<CountdownProps> = ({ timer, onStop }) => {
    const { minutes, seconds } = useCountdown({ onStop, ...timer });

    return (
        <div>
            <span>{minutes}</span> : <span>{seconds}</span>
        </div>
    );
};
